<div [style]="'height: ' + (getHeight() == 0 ? '100%' : getHeight() + 'px')">
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <mat-form-field>
        <mat-label>{{getSearchPlaceholder()}}</mat-label>
        <mat-chip-list #chipList>
          <mat-chip *ngFor="let search of (_value?.searchTerms ?? [])" class="remove-chip" [removable]="true" (removed)="onRemoveSearch(search)">
            {{search}}
            <span class="fas fa-times-circle" title="Delete" matChipRemove></span>
          </mat-chip>
          <input matInput [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="onAddSearch($event)">
        </mat-chip-list>
      </mat-form-field>
    </div>
  </div>
</div>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="spinner-item" *ngIf="reloading">
        <mat-progress-spinner [mode]="'indeterminate'" [diameter]="50">
        </mat-progress-spinner>
      </div>
      <div #scrollDiv (scroll)="onScroll($event)" [style]="'height: ' + (getHeight() == 0 ? '100vh' : (getHeight() - 75) + 'px')">
        <mat-list (scroll)="onScroll($event)" [style]="'height: ' + (getHeight() == 0 ? '100vh' : (getHeight() - 75) + 'px; overflow-y: scroll;')">
          <ng-container *ngIf="getShowSelected()">
            <ng-container *ngFor="let selectedValue of _value.selectedValues">
              <mat-list-item>
                <div class="row">
                  <div class="col-md-6 select-checkbox" style="background-color: rgba(255, 255, 0, 0.5)">
                    <mat-checkbox [checked]="isSelected(selectedValue)" (change)="checkChanged($event, selectedValue)">{{getDisplay(selectedValue)}}</mat-checkbox>
                  </div>
                </div>
              </mat-list-item>
            </ng-container>
          </ng-container>
          <ng-container *ngFor="let sourceValue of sourceValues">
            <mat-list-item>
              <div class="row">
                <div class="col-md-6 select-checkbox">
                  <mat-checkbox [checked]="isSelected(sourceValue)" (change)="checkChanged($event, sourceValue)">{{getDisplay(sourceValue)}}</mat-checkbox>
                </div>
              </div>
            </mat-list-item>
          </ng-container>
          <div *ngIf="loading" class="spinner-item">
            <mat-progress-spinner [mode]="'indeterminate'" [diameter]="50">
            </mat-progress-spinner>
          </div>
        </mat-list>
      </div>
    </div>
  </div>
</div>
</div>
